import { queryClient } from "@/constants";
import "../styles/globals.css";

import routes from "@/routes";
import { theme } from "@/services/antd-theme";
import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import "dayjs/locale/my";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { createHashRouter, RouterProvider } from "react-router";

// dayjs.locale("my");

export function App() {
	const router = createHashRouter(routes);

	return (
		<HelmetProvider>
			<QueryClientProvider client={queryClient}>
			<ConfigProvider
				theme={theme}
				// locale={locale}
			>
				<Helmet>
					<title>ဓမ္မအောင်လံ ဝိပဿနာရိပ်သာ</title>
					<meta
						name="description"
						content="ဓမ္မအောင်လံ ဝိပဿနာရိပ်သာ Admin Dashboard"
					/>
					<meta
						name="viewport"
						content="width=device-width, initial-scale=1"
					/>
					<link
						rel="icon"
						type="image/png+xml"
						href="/assets/dhamha_aung_lan_logo.png"
					/>
				</Helmet>
				<RouterProvider router={router} />
			</ConfigProvider>
		</QueryClientProvider>
		</HelmetProvider>
	);
}
